import { createComponentBroadcast } from '../../common-scripts/componentBroadcast'
import ursLoginModal from '../urs-login-modal/ursLoginModal'
import ursComponentSteps from './ursComponentSteps'
import logger from '../../common-scripts/logger'
import { requestMethod } from '../../common-scripts/request'
import ursPostMessage from '../urs-post-message/ursPostMessage'
import usrRegisterSuccess from '../urs-register-success/usrRegisterSuccess'
import ursLoginComponent from '../urs-login-component/ursLoginComponent'
import { inputChangeStyle } from '../../common-scripts/commonMethod'

const actionSuccess = usrRegisterSuccess.actions
const successBroadcast = createComponentBroadcast(usrRegisterSuccess)
const actionsMessage = ursPostMessage.actions
const messageBroadcast = createComponentBroadcast(ursPostMessage)

const actionsLoginComponent = ursLoginComponent.actions
const loginComponentBroadcast = createComponentBroadcast(ursLoginComponent)

const $isAgree = $('#is-agree')
const $companyName = $('#company-person-name')
const $selChannle = $('.sel-channle')
const $postMessage = $('.urs-post-message')
const $mobile = $('#contact-phone') //手机号输入框
const $validCode = $('#valid-code') //验证码输入框
const { selector, actions } = ursComponentSteps
const $step = $(selector)
const stepBroadcast = createComponentBroadcast(ursComponentSteps)

$(function() {
  const unSelect = '#909299'
  const selected = '#2E2F33'
  $selChannle.css('color', unSelect)
  $('.sel-channle option').css('color', selected)
  $selChannle.change(function() {
    $(this).css({ color: selected, 'font-weight': 550 })
  })
  $('#close-btn-step').click(function() {
    const { actions } = ursLoginModal
    const modalBroadcast = createComponentBroadcast(ursLoginModal)
    modalBroadcast.trigger(actions.hide)
    stepBroadcast.trigger(actions.hide)
    loginComponentBroadcast.trigger(actionsLoginComponent.show)
  })

  stepBroadcast.on(actions.show, () => {
    logger.log('modalBroadcast show....')
    $step.css('display', 'block')
  })

  stepBroadcast.on(actions.hide, () => {
    $('.mark-err').hide()
    $('.get-valid-code').text('获取验证码')
    logger.log('modalBroadcast hide....')
    $step.css('display', 'none')
  })

  stepBroadcast.on(actions.ticket, (event: any, datas: any) => {
    const $codeValueText = $('.code-value').text()
    const areaCode = $codeValueText.split('+')[1] //86
    const areaCodeOrigin = $('.code-value').text() //+86
    const mobileNumber = $mobile.val()
    let mobileCode = ''
    if (areaCodeOrigin.indexOf('+86') == -1) {
      mobileCode = `${areaCode}-${mobileNumber}`.replace(/\s/gi, '')
    } else {
      mobileCode = `${mobileNumber}`
    }
    if (datas.result && datas.result.code == 201) {
      const url = '/registerUrs.s'
      const methods = 'GET'
      const data = {
        ticket: datas.result.cookie,
        mobile: mobileCode,
        company: $companyName.val(),
        infoSource: $selChannle.val(),
      }
      requestMethod(url, methods, data)
        .then((datas) => {
          const { code, msg } = datas
          if (code == 200) {
            //提交成功代码
            const { redirectUrl } = datas
            stepBroadcast.trigger(actions.hide)
            successBroadcast.trigger(actionSuccess.show, redirectUrl)
          } else {
            alert(msg)
          }
        })
        .catch((err) => {
          alert(JSON.stringify(err))
        })
    } else {
      //验证码不通过处理
      $('.err-valid p').text(datas.result.msg)
      $('.err-valid').css('display', 'flex')
    }
  })
  $('#company-person-name').focus(function() {
    $('.mark-err').hide()
  })
  $('.sel-channle').focus(function() {
    $('.mark-err').hide()
  })
  $('#is-agree').click(function() {
    $('.mark-err').hide()
  })
  $('#submit-info').click(function() {
    const isRequireMobile = $postMessage.css('display') == 'block'
    const nameValue = $companyName.val() as string
    if (isRequireMobile) {
      if (!nameValue) {
        $('.mark-err').hide()
        $('.err-name p').text('请输入公司名称或个人开发者名称')
        $('.err-name').css('display', 'flex')
      } else if (nameValue.length > 20) {
        $('.err-name p').text('不能超过20字符')
        $('.err-name').css('display', 'flex')
      } else if (nameValue.indexOf(' ') !== -1) {
        $('.err-name p').text('名称中不允许存在空格符')
        $('.err-name').css('display', 'flex')
      } else if (!$selChannle.val()) {
        $('.err-channel').css('display', 'flex')
      } else if (!$isAgree.is(':checked')) {
        $('.err-clause').css('display', 'flex')
      } else {
        const validCode = $validCode.val()
        const mobileNumber = $mobile.val()
        let mobileCode = ''
        const areaCode = $('.code-value')
          .text()
          .split('+')[1]
        const areaCodeOrigin = $('.code-value').text()
        if (areaCodeOrigin.indexOf('+86') == -1) {
          mobileCode = `${areaCode}-${mobileNumber}`.replace(/\s/gi, '')
        } else {
          mobileCode = `${mobileNumber}`
        }
        if (validCode && mobileCode) {
          const resData = { validCode, mobileCode }
          messageBroadcast.trigger(actionsMessage.getCookie, resData)
        } else {
          $('.err-valid p').text('请输入正确验证码')
          $('.err-valid').css('display', 'flex')
        }
      }
    } else if (!nameValue) {
      $('.err-name p').text('请输入公司名称或个人开发者名称')
      $('.err-name').css('display', 'flex')
    } else if (nameValue.length > 20) {
      $('.err-name p').text('不能超过20字符')
      $('.err-name').css('display', 'flex')
    } else if (nameValue.indexOf(' ') !== -1) {
      $('.err-name p').text('名称中不允许存在空格符')
      $('.err-name').css('display', 'flex')
    } else if (!$selChannle.val()) {
      $('.err-channel').css('display', 'flex')
    } else if (!$isAgree.is(':checked')) {
      $('.err-clause').css('display', 'flex')
    } else {
      logger.log('可以提交')
      const url = '/registerUrs.s'
      const methods = 'GET'
      const data = {
        company: $companyName.val(),
        infoSource: $selChannle.val(),
      }
      requestMethod(url, methods, data)
        .then((datas) => {
          const { code, msg } = datas
          if (code == 200) {
            const { redirectUrl } = datas
            //提交成功代码
            stepBroadcast.trigger(actions.hide)
            successBroadcast.trigger(actionSuccess.show, redirectUrl)
          } else {
            alert(msg)
          }
          logger.log(datas)
        })
        .catch((err) => {
          logger.log(err)
        })
    }
  })

  $('#contact-phone').on('input propertychange', function() {
    inputChangeStyle('#contact-phone')
  })
  $('#valid-code').on('input propertychange', function() {
    inputChangeStyle('#valid-code')
  })
  $('#company-person-name').on('input propertychange', function() {
    inputChangeStyle('#company-person-name')
  })
})
